import { getEngageObjectTypeIdByName } from '../../Services/engage';
import { EngageObject } from '../../Types/engage';
import { Journey } from '../../Types/journey';

export type JourneyLookupItem = {
	Id?: number;
	PluginInstanceId?: number;
	EngageObjectType?: number;
};

export function resolveCurrentObjectType(item?: JourneyLookupItem, typeName?: string): number | undefined {
	if (item?.EngageObjectType && item.EngageObjectType > 0) return item.EngageObjectType;
	if (!typeName) return undefined;
	return getEngageObjectTypeIdByName(typeName);
}

export function resolveCurrentItemId(item?: JourneyLookupItem): number | undefined {
	if (!item) return undefined;
	if (item.PluginInstanceId && item.PluginInstanceId > 0) return item.PluginInstanceId;
	if (item.Id && item.Id > 0) return item.Id;
	return undefined;
}

export function resolveJourney(journeys: Journey[], currentItemId?: number, currentObjectType?: number): Journey | undefined {
	if (!journeys || journeys.length === 0) return undefined;

	if (currentItemId && currentItemId > 0) {
		const itemJourney = journeys.find((journey) =>
			(journey.EngageObjects || []).some((journeyObject) => {
				if (!currentObjectType) return journeyObject.Id === currentItemId;
				return journeyObject.Id === currentItemId && journeyObject.EngageObjectType === currentObjectType;
			})
		);
		if (itemJourney) return itemJourney;
	}

	return undefined;
}

export function isCurrentItem(item: EngageObject, currentItemId?: number, currentObjectType?: number): boolean {
	if (!currentItemId) return false;
	if (!currentObjectType) return item.Id === currentItemId;
	return item.Id === currentItemId && item.EngageObjectType === currentObjectType;
}